import React, { useState, useEffect } from 'react';
import {
  Select,
  MenuItem,
  InputBase,
  withStyles,
  FormControl,
  makeStyles,
  useTheme,
  Checkbox,
  ListItemText,
  FormHelperText,
} from '@material-ui/core';
import KenTextLabel from '../KenTextLabel';
import KenCheckbox from '../KenCheckbox';
import { Check } from '@material-ui/icons';
import clsx from 'clsx';
import StatusWarningIcon from '../../Assets/icons/warning.svg';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

function getStyles(name, value, theme) {
  return {
    fontWeight:
      value.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: 2,
  },
  selectMenuItem: {
    '&.Mui-selected': {
      backgroundColor: `1px solid ${theme.palette.KenColors.primary}`,
      fontWeight: 600,
    },
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 8,
    position: 'relative',
    // backgroundColor: '#FAFBFC',
    border: '1px solid #ced4da',
    fontSize: 14,
    height: 16,
    padding: '11px 12px',
    textAlign: 'left',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
    //   ...inputStyles,
  },
}))(InputBase);

const KenSelect = function (props) {
  const {
    id,
    options = [],
    value,
    onChange,
    label,
    name,
    placeholder,
    disabled,
    readonly,
    defaultValue,
    required,
    multiple = false,
    optionalLabel = true,
    dropdownColor,
    inputInputProps,
    menuItemProps,
    selectMultiple = false,
    setFormValues,
    formValues,
    IconComponent,
    errors,
  } = props;
  const iconStyles = {
    selectIcon: {
    }
  };
  const CustomExpandMore = withStyles(iconStyles)(
    ({ className, classes, ...rest }) => {
      return (
        <ExpandMoreIcon
          {...rest}
          className={clsx(className, classes.selectIcon)}
        />
      );
    }
  );
  const useStyles = makeStyles((theme) => ({
    label: {
      marginBottom: 2,
    },
    selectMenuItem: {
      '&.Mui-selected': {
        // background: selectedMenuColor,
        color: '#DE350B',
        fontWeight: 600,
      },
      menuitemhidden: {
        display: 'none',
      },
      placeholder: {
        color: '#7A7A7B',
        fontSize: '14px',
        fontFamily: 'Work Sans',
        fontWeight: 500,
      },
      StyledropDown:{
        border: '1px solid #ced4da',
      }
    },
  }));
  const [itemsChecked, setItemsChecked] = useState(false);
  const [checkedList, setCheckedList] = useState([]);

  const classes = useStyles();

  const handleCheck = (elem) => {
    if (value?.includes(elem.value)) {
      return true;
    }
    return false;
  };

  const handleRenderValue = (selected) => {
    if (!selected) {
      return placeholder;
    }
    if (multiple) {
      return selected.map(
        (el) => options.find((item) => item.value === el)?.label
      );
    } else {
      return options.find((item) => item.value === selected)?.label;
    }
  };

  const handleCheckboxClick = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setCheckedList([...checkedList, value]);
      if (selectMultiple) {
        setFormValues({
          ...formValues,
          TermNumber: [...checkedList, value],
        });
      }
      return e.target.checked === true;
    } else {
      setCheckedList(checkedList.filter((item) => item !== value));
      if (selectMultiple) {
        setFormValues({
          ...formValues,
          TermNumber: checkedList.filter((item) => item !== value),
        });
      }
    }
  };
  console.log('checkedList', value);

  const selectItem = (e) => {
    const { checked } = e.target;
    const collection = [];

    if (checked) {
      for (const option of options) {
        collection.push(option.value);
      }
    }
    if (selectMultiple) {
      setFormValues({
        ...formValues,
        TermNumber: collection,
      });
    }

    setCheckedList(collection);
    setItemsChecked(checked);
  };

  const theme = useTheme();
  return (
    <FormControl
      fullWidth
      disabled={disabled || readonly}
      className={classes.formControl}
    //   variant="filled"
    >
      <KenTextLabel
        label={label}
        required={required}
        optionalLabel={optionalLabel}
        style={{fontSize:'11px',fontWeight:600}}
      />

      <Select
        data-testid="kenSelect"
        id={id}
        inputProps={{ id: 'my-select' }}
        IconComponent={CustomExpandMore}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        disabled={disabled || readonly}
        fullWidth
        placeholder={placeholder}
        input={<BootstrapInput value={value} inputProps={inputInputProps} />}
        required={required}
        multiple={multiple}
        defaultValue={defaultValue}
        displayEmpty={true}
        style={{ backgroundColor: dropdownColor,borderRadius:'8px'}}
        renderValue={(selected) => {
          return multiple
            ? handleRenderValue(selected).join(',')
            : handleRenderValue(selected);
        }}
        {...props}
      >
        <MenuItem
          className={clsx(
            classes.menuitem,
            !placeholder ? classes.menuitemhidden : classes.placeholder
          )}
          key="0"
          disabled
          value="none"
        >
          {placeholder}
        </MenuItem>

        {selectMultiple && options.length > 0 && (
          <MenuItem>
            <Checkbox checked={itemsChecked} onClick={selectItem} />
            Select all
          </MenuItem>
        )}
        {options.map((el) => (
          <MenuItem
            key={el?.label || el}
            value={el?.value || el}
            name={el?.value || el}
            style={
              multiple
                ? getStyles(name, value, theme)
                : { backgroundColor: el?.backgroundColor }
            }
            selected={value === el?.value}
            classes={{ selected: classes.selectMenuItem }}
            // onClick={handleSelectMenu}
            disabled={
              menuItemProps?.condition === 0
                ? false
                : menuItemProps?.condition
                ? el?.value < menuItemProps?.condition
                : menuItemProps?.menuItemDisabled
            }
            {...menuItemProps}
          >
            {multiple && (
              <Checkbox
                id={el.value}
                item={el.value}
                value={el.value}
                // checked={checkedList.includes(el.value) ? true : false}
                checked={value.indexOf(el.value) > -1}
              // onClick={handleCheckboxClick}
              />
            )}

            <ListItemText primary={el?.label || el} />
          </MenuItem>
        ))}
      </Select>
      {errors && (
        <span style={{ color: '#FF991F' }}>
          <img src={StatusWarningIcon} width={'15px'} alt="warning"></img> Field
          cannot be empty.
        </span>
      )}
    </FormControl>
  );
};

const KenSelectWrap = (props = {}) => {
  const options = props?.options?.map((option) =>
    typeof option === 'string' || option instanceof String
      ? { label: option, value: option }
      : option
  );

  return <KenSelect {...props} options={options} />;
};
export default KenSelectWrap;
